import { render, staticRenderFns } from "./PlayerProProfile.vue?vue&type=template&id=023c52a4&scoped=true"
import script from "./PlayerProProfile.vue?vue&type=script&lang=js"
export * from "./PlayerProProfile.vue?vue&type=script&lang=js"
import style0 from "./PlayerProProfile.vue?vue&type=style&index=0&id=023c52a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023c52a4",
  null
  
)

export default component.exports